import React, { useEffect, useRef, useState } from "react";
import { MdOutlineEdit } from "react-icons/md";
import {
  DROPDOWN_DETAILS,
  USER_DETAILS,
  Transfer_ID,
} from "../../../Constants/constants";
import Select from "react-select";
import "./index.css";
import {
  CreateUpdateSalesPerson,
  GetAllVerticalKeys,
  getSalesPersonAdditionalDetails,
  fetchSalesPersonById,
  salesPersonPositionCodeChange,
  patchRealmRole,
  GetReportingManagerName,
} from "../../../Services/Dashboard/tableGridService";
import DropDown from "../../DropDown";
import { RiDeleteBin5Line } from "react-icons/ri";
import Dialog from "../../Modal/Dialog";
import ReassignmentModal from "../../Modal/ReassigmentModal";
import { GrAddCircle } from "react-icons/gr";
import { transformPositionCodeDetailsByTrasferId } from "../../../Utils/assignAutoTransferId";
import { EMPLOYEE_TYPE_VALUE } from "../../../Utils/constants";

const UserGridDetails = (props) => {
  const { closeUserDetails, userDetails } = props;
  const { eventData } = userDetails;
  const [localStatus, setLocalStatus] = useState({
    label: USER_DETAILS.ACTIVE,
    value: USER_DETAILS.ACTIVE,
  });
  const [verticals, setVerticals] = useState({});
  const [isStatusActive, setIsStatusActive] = useState(false);
  const [additionalFields, setAdditionalFields] = useState([]);
  const [showUserId, setShowUserId] = useState();
  const [verticalFields, setVerticalFields] = useState([]);
  const [updateUserDetails, setUpdateUserDetails] = useState();
  const [isEditable, setIsEditable] = useState(true);
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);
  const [remapVerticals, setRemapVerticals] = useState([]);
  const [reportingSalesPersonData, setReportingSalesPersonData] = useState({});
  const [updateUserLoader, setUpdateUserLoader] = useState(false);
  const [isApisLoading, setIsApisLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");

  const statusDropDownOptions = [
    { label: USER_DETAILS.ACTIVE, value: USER_DETAILS.ACTIVE },
    { label: USER_DETAILS.INACTIVE, value: USER_DETAILS.INACTIVE },
  ];

  const fetchAdditionalSalesPersonsDetails = () => {
    getSalesPersonAdditionalDetails({
      input: {
        salesPersonId: eventData.id,
        fetchPositionCodeAdditionalDetails: "true",
        fetchSalesPersonToPositionCodeTimeline: "false",
      },
    })
      .then((res) => {
        const data = res?.data?.data;
        setLocalStatus({ label: eventData?.status, value: eventData?.status });
        setVerticals({
          refType: data?.salesPersonAdditionalDetails?.refType,
          refValue: data?.salesPersonAdditionalDetails?.refValue,
        });
        const positionDetailsModified =
          data?.positionCodeAdditionalDetails?.map((codeDetails) => {
            const positionCodeAdditionalDetails =
              codeDetails?.positionCodeAdditionalDetails
                ?.filter((ele) => ele?.refType?.trim() !== "T")
                ?.map((ele) => ({
                  ...ele,
                  refType: ele.refType?.trim(),
                }));

            return {
              positionCodeAdditionalDetails,
              uniqueId: Math.random(),
              isExistingUser: true,
            };
          });
        setAdditionalFields(positionDetailsModified);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const fetchActiveUserDetails = () => {
    if (eventData?.status === USER_DETAILS.ACTIVE) {
      setIsStatusActive(true);
      GetAllVerticalKeys({
        input: {
          refType: DROPDOWN_DETAILS.VERTICAL,
          refValue: verticals.refValue,
        },
      })
        .then((res) => {
          setVerticalFields(res?.data?.data || []);
        })
        .catch((error) => {
          setErrorMessage(
            "Unable to fetch vertical fields at the moment, Please refresh the page *"
          );
          console.log(error);
        });
    } else {
      setIsStatusActive(false);
      setLoading(false);
    }
  };
  const eventDataRef = useRef(eventData);
  eventDataRef.current = eventData;
  const fetchAdditionalSalesPersonsDetailsRef = useRef(fetchAdditionalSalesPersonsDetails);
  fetchAdditionalSalesPersonsDetailsRef.current = fetchAdditionalSalesPersonsDetails;

  useEffect(() => {
    const eventData = eventDataRef.current;
    const fetchAdditionalSalesPersonsDetails = fetchAdditionalSalesPersonsDetailsRef.current;
    setIsEditable(true);
    setLoading(true);
    if (eventData?.id) {
      fetchSalesPersonById(eventData?.id)
        .then((res) => {
          const reportingSalesPersonId =
            res?.data?.salesHierarchy?.reportingSalesPersonId;
          if (reportingSalesPersonId) {
            fetchSalesPersonById(reportingSalesPersonId).then((response) => {
              response?.data?.userId && setShowUserId(response?.data?.userId);
              setUpdateUserDetails({
                ...eventData,
                reportingSalesPersonData: response?.data || {},
              });
              fetchAdditionalSalesPersonsDetails();
            });
          } else {
            setUpdateUserDetails(eventData);
            fetchAdditionalSalesPersonsDetails();
          }
        })
        .catch(() => {
          setUpdateUserDetails(eventData);
        });
    } else {
      fetchAdditionalSalesPersonsDetails();
    }
  }, [eventData?.id]);

  let uniqueKeys = Array.from(
    new Set(
      (verticalFields || [])
        .map((item) => item.refType?.trim())
        .filter((refType) => refType && refType !== "T")
    )
  );

  let dropdownOptions = [];

  verticalFields &&
    Array.isArray(verticalFields) &&
    verticalFields?.forEach((item) => {
      dropdownOptions.push({
        label: item.refValue,
        value: { refType: item.refType, refValue: item.refValue },
      });
    });
  const getDropdownFields = (name) => {
    const filteredDropdownFields = dropdownOptions.filter((ele) => {
      return ele?.value?.refType === name;
    });
    return filteredDropdownFields;
  };

  const onEditClick = () => {
    deleteVertical.length && setRemapVerticals([]);
    setIsEditable(!isEditable);
  };

  const onChangeStatus = (event) => {
    setLocalStatus({ label: event.value, value: event.value });
    if (event.value === USER_DETAILS.ACTIVE && verticals?.refValue) {
      GetAllVerticalKeys({
        input: {
          refType: DROPDOWN_DETAILS.VERTICAL,
          refValue: verticals?.refValue,
        },
      })
        .then((res) => {
          setVerticalFields(res?.data?.data || []);
          fetchAdditionalSalesPersonsDetails();
        })
        .catch((error) => {
          setErrorMessage(
            "Unable to fetch vertical fields at the moment, Please refresh the page *"
          );
          console.log(error);
        });
      setIsStatusActive(true);
    } else {
      setIsStatusActive(false);
      const remapVerticalsCopy = remapVerticals.slice();
      setRemapVerticals(remapVerticalsCopy.concat(additionalFields));
    }
    setErrorMessage("");
    const value = event?.value;
    setUpdateUserDetails((prevState) => {
      return {
        ...prevState,
        status: value,
      };
    });
  };

  const handleInput = (event) => {
    setErrorMessage("");
    const { name, value } = event.target;
    setUpdateUserDetails((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });
  };

  const verticalSelectOnChange = async (
    action,
    positionCodeIndex,
    refIndex
  ) => {
    const editVerticals = additionalFields?.slice();
    try {
      setIsApisLoading(true);
      const [modifiedVertical] =
        (await transformPositionCodeDetailsByTrasferId(
          editVerticals,
          positionCodeIndex,
          refIndex,
          action.value.refValue
        )) || [];
      setAdditionalFields(modifiedVertical || editVerticals);
      setIsApisLoading(false);
    } catch (e) {
      setIsApisLoading(false);
      throw e;
    }
  };

  const addVertical = () => {
    const newRow = [];
    uniqueKeys?.map((ele) => newRow?.push({ refType: ele }));
    newRow.push({ refType: Transfer_ID });
    const additionalFieldsCopy = additionalFields?.slice();
    additionalFieldsCopy?.push({
      positionCodeAdditionalDetails: newRow,
      uniqueId: Math.random(),
    });
    setAdditionalFields(additionalFieldsCopy);
  };

  const deleteVertical = (index) => {
    const modifiedRow = additionalFields?.slice();
    const deletedRow = modifiedRow?.splice(index, 1);
    deletedRow?.length &&
      deletedRow[0]?.positionCodeAdditionalDetails?.length &&
      deletedRow[0]?.positionCodeAdditionalDetails[0].positionCodeId &&
      setRemapVerticals((state) => [...state, ...deletedRow]);
    setAdditionalFields(modifiedRow);
  };

  const onChangeReportingManager = (event) => {
    setShowUserId(event?.value?.userId);
    setUpdateUserDetails({
      ...updateUserDetails,
      reportingSalesPersonId: event?.value?.id,
    });
  };

  const fetchManagers = async (name) => {
    setIsLoading(true);
    try {
      const body = {
        inputParameters: {
          queryName: "dynamic_search_sales_person_by_name",
          name,
        },
      };
      const response = await GetReportingManagerName(body);

      const fetchedOptions =
        response?.data?.data?.map((manager) => ({
          label: manager?.empName,
          value: manager || {},
        })) || [];

      setOptions(fetchedOptions);
    } catch (error) {
      console.error("Error fetching managers:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInputChange = (value) => {
    setInputValue(value);
    if (value.length >= 3) {
      fetchManagers(value);
    } else {
      setOptions([]);
    }
  };

  const checkRefValue = (index) => {
    const isRefValue = additionalFields[index]?.positionCodeAdditionalDetails
      ?.filter((item) => item.refType !== Transfer_ID)
      .find((item) => !item.refValue);
    if (!isRefValue) {
      return false;
    } else {
      return true;
    }
  };

  const onSave = () => {
    if (updateUserDetails?.status === USER_DETAILS.INACTIVE) {
      if (remapVerticals.length || additionalFields.length) {
        fetchSalesPersonByIdTransformFn();
      } else if (!remapVerticals.length) {
        submitSalesPersonData();
      }
    } else {
      if (remapVerticals.length) {
        fetchSalesPersonByIdTransformFn();
      } else {
        submitSalesPersonData();
      }
    }
  };

  const fetchSalesPersonByIdTransformFn = async () => {
    try {
      updateUserDetails?.reportingSalesPersonData &&
        setReportingSalesPersonData(
          updateUserDetails?.reportingSalesPersonData
        );
      setIsShowModal(true);
    } catch (e) {}
  };

  const submitSalesPersonData = () => {
    setUpdateUserLoader(true);
    setErrorMessage("");
    CreateUpdateSalesPerson({
      empCode: updateUserDetails.empCode,
      empName: updateUserDetails.empName,
      empEmail: updateUserDetails.empEmail,
      empPhoneNumber: updateUserDetails.empPhoneNumber,
      empType: updateUserDetails.empType,
      userId: updateUserDetails.userId,
      realmId: updateUserDetails.realmId,
      status: updateUserDetails.status,
      reportingSalesPersonId: updateUserDetails.reportingSalesPersonId,
      salesPersonAdditionalDetails: [verticals],
      positionCodeAdditionalDetails:
        localStatus.value === USER_DETAILS.ACTIVE ? additionalFields : [],
    })
      .then((res) => {
        setUpdateUserLoader(false);
        closeUserDetails({
          fetchData: true,
        });
        if (updateUserDetails?.empType !== eventData?.empType) {
          onPatchRealmRole();
        }
      })
      .catch((error) => {
        setUpdateUserLoader(false);
        setErrorMessage("Unable to fetch vertical fields at the moment *");
        console.log(error);
      });
  };

  const onDiscard = () => {
    closeUserDetails();
  };
  const onCloseReassigmentModal = () => {
    setIsShowModal(false);
  };
  const getTransferIdValue = (positionCodeIndex) => {
    return (
      additionalFields[positionCodeIndex]?.positionCodeAdditionalDetails?.find(
        (pca) => pca.refType === Transfer_ID
      )?.refValue || ""
    );
  };
  const onSubmitRemap = async (body) => {
    try {
      setIsShowModal(true);
      const res = await salesPersonPositionCodeChange(body);
      setIsShowModal(false);
      if (res) {
        submitSalesPersonData();
      }
    } catch (e) {
      setIsShowModal(false);
      throw e;
    }
  };

  const fetchActiveUserDetailsRef = useRef(fetchActiveUserDetails);
  fetchActiveUserDetailsRef.current = fetchActiveUserDetails;

  useEffect(() => {
    if (verticals?.refValue) {
      fetchActiveUserDetailsRef.current();
    }
  }, [verticals?.refValue]);

  const verticalOnChange = (selectedVertical) => {
    !additionalFields.length && addVertical();
  };

  const onPatchRealmRole = async () => {
    try {
      setLoading(true);
      const body = {
        input: {
          contactNumber: eventData.empPhoneNumber,
          existingRole: eventData.empType,
          newRole: updateUserDetails.empType,
        },
      };
      await patchRealmRole(body);
      setLoading(false);
    } catch (err) {
      throw Error(err);
    }
  };
  return (
    <>
      {loading ? (
        <h2 className="text-base font-bold">Loading....</h2>
      ) : (
        <div style={{ position: "relative" }}>
          <div className="user-detail-parent-container">
            <div className="user-detail-inner-container">
              <div className="user-detail-heading-container">
                <h3 className="text-base font-bold">Sales Person Details</h3>
                <div className="flex items-center text-base font-bold">
                  <span>Edit User Details</span>
                  <MdOutlineEdit
                    style={{ cursor: "pointer", marginLeft: 10 }}
                    onClick={() => onEditClick()}
                  />
                </div>
              </div>
              <div className="user-detail-data-container">
                <div className="user-detail-data-input-container">
                  <label>Emp Name</label>
                  <input
                    name="empName"
                    onChange={(e) => handleInput(e)}
                    disabled={isEditable}
                    value={updateUserDetails?.empName}
                    className="user-detail-input"
                  />
                </div>
                <div className="user-detail-data-input-container">
                  <label>Phone Number</label>
                  <input
                    type="number"
                    name="empPhoneNumber"
                    onChange={(e) => handleInput(e)}
                    disabled={isEditable}
                    value={updateUserDetails?.empPhoneNumber}
                    className="user-detail-input"
                  />
                </div>
              </div>
              <div className="user-detail-data-container">
                <div className="user-detail-data-input-container">
                  <label>Emp Email</label>
                  <input
                    name="empEmail"
                    onChange={(e) => handleInput(e)}
                    disabled={isEditable}
                    value={updateUserDetails?.empEmail}
                    className="user-detail-input"
                  />
                </div>
                <div className="user-detail-data-input-container">
                  <label>Employee Type</label>
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        width: 225,
                      }),
                    }}
                    isDisabled={isEditable}
                    name="empType"
                    defaultValue={{
                      label: eventData?.empType,
                      value: eventData?.empType,
                    }}
                    options={EMPLOYEE_TYPE_VALUE.map((type) => ({
                      value: type,
                      label: type,
                    }))}
                    onChange={(e) => {
                      setUpdateUserDetails((prevState) => {
                        return {
                          ...prevState,
                          empType: e?.value,
                        };
                      });
                    }}
                  />
                </div>
              </div>
              <div className="user-detail-data-container">
                <div className="user-detail-data-input-container">
                  <label>Status</label>
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        width: 225,
                      }),
                    }}
                    isDisabled={isEditable}
                    name={"activity"}
                    defaultValue={localStatus}
                    options={statusDropDownOptions}
                    onChange={(e) => onChangeStatus(e)}
                  />
                </div>
                <div className="user-detail-data-input-container">
                  <label>Reporting Manager Name</label>
                  <Select
                    styles={{
                      control: (baseStyles) => ({
                        ...baseStyles,
                        width: 225,
                      }),
                    }}
                    defaultValue={{
                      label:
                        updateUserDetails?.reportingSalesPersonData?.empName,
                      value:
                        updateUserDetails?.reportingSalesPersonData?.empName,
                    }}
                    isDisabled={isEditable}
                    options={options}
                    isLoading={isLoading}
                    onInputChange={handleInputChange}
                    onChange={(selectedOption) =>
                      onChangeReportingManager(selectedOption)
                    }
                    noOptionsMessage={() =>
                      inputValue.length < 3
                        ? "Enter at least 3 characters"
                        : "No results found"
                    }
                    placeholder="Search for a manager..."
                    isClearable
                  />
                </div>
              </div>
            </div>
            <div className="user-detail-data-container">
              <div className="user-detail-data-input-container">
                <label>Asgard Id</label>
                <input
                  name="userId"
                  type="number"
                  onChange={(e) => handleInput(e)}
                  disabled={isEditable}
                  value={updateUserDetails?.userId}
                  className="user-detail-input"
                />
              </div>
              <div className="user-detail-data-input-container">
                <label>Reporting Manager UserId</label>
                <input
                  name="reportingSalesPersonId"
                  disabled={true}
                  value={showUserId}
                  className="user-detail-input"
                />
              </div>
            </div>
            <div className="user-detail-data-container">
              <div className="user-detail-data-input-container">
                <label>Employee code</label>
                <input
                  name="empCode"
                  onChange={(e) => handleInput(e)}
                  disabled={isEditable}
                  value={updateUserDetails?.empCode}
                  className="user-detail-input"
                />
              </div>
            </div>
            <br />
            {isStatusActive && (
              <div>
                <div className="add-new-user-inner-data-container">
                  <div className="add-new-user-inner-data-input-container">
                    <label>Vertical</label>
                    <Select
                      styles={{
                        control: (baseStyles, state) => ({
                          ...baseStyles,
                          width: 154,
                        }),
                      }}
                      onChange={verticalOnChange}
                      defaultValue={{
                        label: verticals.refValue,
                        value: verticals.refValue,
                      }}
                      options={[
                        {
                          label: verticals.refValue,
                          value: verticals.refValue,
                        },
                      ]}
                      isDisabled={isEditable}
                    />
                  </div>
                </div>
                {additionalFields?.map((data, index) => {
                  const isRefValuePresent = checkRefValue(index);
                  return (
                    <div
                      className="user-detail-user-creatable-dropdown-container"
                      key={data?.uniqueId}
                    >
                      <div className="d-flex">
                        <DropDown
                          selected={true}
                          uniqueKeys={uniqueKeys}
                          getDropdownFields={getDropdownFields}
                          selectOnChange={verticalSelectOnChange}
                          data={data}
                          positionCodeIndex={index}
                          isEditable={isEditable}
                        >
                          <label style={{ marginRight: "10px" }}>
                            Transfer ID
                          </label>
                          <input
                            readOnly
                            name="transferId"
                            style={{ width: "196px" }}
                            onChange={(e) =>
                              verticalSelectOnChange(
                                {
                                  label: e.target.value,
                                  value: { refValue: e.target.value },
                                },
                                index,
                                uniqueKeys?.length
                              )
                            }
                            disabled={isEditable}
                            value={getTransferIdValue(index)}
                            className="user-detail-input"
                          />
                        </DropDown>
                      </div>
                      <div>
                        {uniqueKeys.length > 0 &&
                          !isRefValuePresent &&
                          !isEditable &&
                          additionalFields.length === index + 1 && (
                            <GrAddCircle
                              className="user-detail-user-creatable-dropdown-button"
                              onClick={() => addVertical()}
                            />
                          )}
                        {index >= 0 && !isEditable && (
                          <RiDeleteBin5Line
                            className="user-detail-user-creatable-dropdown-button"
                            onClick={() => deleteVertical(index)}
                          />
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            <div className="user-detail-button-container">
              <button
                onClick={() => onSave()}
                className="user-detail-save-changes-btn"
                disabled={isApisLoading || isEditable}
              >
                Save Changes
              </button>
              <button
                onClick={() => onDiscard()}
                className="user-detail-discard-btn"
              >
                Discard
              </button>
            </div>
            {errorMessage !== "" && (
              <h3 className="text-base font-bold user-detail-user-error-message">
                {errorMessage}
              </h3>
            )}
          </div>
          {/* Temp Filx for loading... */}
          {updateUserLoader && (
            <div className="loading-text-wrapper">
              <div className="loading-text">Loading</div>
            </div>
          )}
        </div>
      )}
      {isShowModal && remapVerticals?.length > 0 && (
        <Dialog
          title="REASSIGNMENT"
          style={{ background: "rgba(241, 255, 253, 0.80)" }}
          onClose={onCloseReassigmentModal}
        >
          <ReassignmentModal
            verticals={remapVerticals.map((vertical) => ({
              ...vertical,
              id: updateUserDetails.id,
            }))}
            reportingSalesPersonData={reportingSalesPersonData}
            remapFn={onSubmitRemap}
          />
        </Dialog>
      )}
    </>
  );
};

export default UserGridDetails;
